import axios from 'axios';
import { baseURL } from '../utility/Constants'; 

const getCoulombMetrics = async (emsName, timeFilter, date) => {
  try {
    const response = await axios.post(`${baseURL}/coulomb-metrics`, {
      emsName,
      timeFilter,
      date
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching coulomb metrics:', error);
    throw error;
  }
};

export const coulombMetricsService = {
  getCoulombMetrics
};

export default coulombMetricsService;
